import View from 'view/view'
import AjaxFormView from 'view/ajax_form'
import ContactCollection from 'bundle/message/collection/contact'
import RecipientSelectBoxView from 'view/recipient_select_box'

export default View.extend({
    _contactCollection: null,
    _contactSelectBox: null,

    events: {
        'click .js-modal-form-button': '_onModalFormButtonClick',
    },

    initialize() {
        this.initSubview(AjaxFormView, {
            el: this.$('.js-ajax-form'),
            onAfterError: this._handleFormError.bind(this),
        })

        this._contactCollection = new ContactCollection()
        this._initContactSelectBox()
    },

    _initContactSelectBox() {
        // TODO INGROUPS-572 Loading spinner should be handled by the component
        this._toggleLoadingIndicator(true)
        this._contactCollection.requestContacts(this._onContactsFetched.bind(this), false, false)
    },

    _onContactsFetched(contacts) {
        // TODO INGROUPS-572 To be replaced by the new UserSelector
        contacts.forEach((contact) => {
            contact.text = contact.name
        })

        this._toggleLoadingIndicator(false)
        this._contactSelectBox = this.initSubview(RecipientSelectBoxView, {
            el: this.$('.js-recipients-select'),
            placeholder: 'Please start typing the name',
            data: contacts,
        })
    },

    _validateForm() {
        if (
            this.$('.js-input-email-list').val().length ||
            // Check if the select box has been initialized (contact list may still be loading).
            // TODO INGROUPS-572 Should be able to create an empty select box and fetch contacts later.
            (this._contactSelectBox && !this._contactSelectBox.isEmpty())
        ) {
            this.$('.js-form-error-no-invitees').addClass('is-hidden')
            return true
        }

        this.$('.js-form-error-no-invitees').removeClass('is-hidden')
        return false
    },

    _handleFormError() {
        this._initContactSelectBox()
    },

    _onModalFormButtonClick(e) {
        if (!this._validateForm()) {
            e.preventDefault()
            return
        }

        this._convertToLegacyInviteIds()
        this.$('.js-ajax-form').trigger('submit')
    },

    // TODO INGROUPS-1000: refactor the BE form to support the select input
    _convertToLegacyInviteIds() {
        const recipients = this.$('.js-recipients-select').val()

        if (recipients) {
            this.$('.js-invite-to-group-inviteIds').val(recipients.join())
        }
    },

    _toggleLoadingIndicator(on) {
        this.$('.js-recipients-edit').toggle(!on)
        this.$('.js-recipients-edit-loading').toggle(on)
    },
})
